// Based on https://github.com/contentful/rich-text/blob/master/packages/rich-text-html-renderer

import React from 'react';
import escape from 'escape-html';
import {
  // Document,
  // Mark,
  // Text,
  BLOCKS,
  MARKS,
  INLINES,
  // Block,
  // Inline,
  helpers,
} from '@contentful/rich-text-types';

const defaultInline = (type, node) =>
  <span>type: {type} id: {node.data.target.sys.id}</span>;

const basicNodeRender = (type) => (node, next, key) =>
  React.createElement(type, { key }, next(node.content));

const basicMarkRender = (type) => (text, key) =>
  React.createElement(type, { key }, text);

const defaultNodeRenderers = {
  [BLOCKS.PARAGRAPH]: basicNodeRender('p'),
  [BLOCKS.HEADING_1]: basicNodeRender('h1'),
  [BLOCKS.HEADING_2]: basicNodeRender('h2'),
  [BLOCKS.HEADING_3]: basicNodeRender('h3'),
  [BLOCKS.HEADING_4]: basicNodeRender('h4'),
  [BLOCKS.HEADING_5]: basicNodeRender('h5'),
  [BLOCKS.HEADING_6]: basicNodeRender('h6'),
  [BLOCKS.EMBEDDED_ENTRY]: basicNodeRender('div'),
  [BLOCKS.UL_LIST]: basicNodeRender('ul'),
  [BLOCKS.OL_LIST]: basicNodeRender('ol'),
  [BLOCKS.LIST_ITEM]: basicNodeRender('li'),
  [BLOCKS.QUOTE]: basicNodeRender('blockquote'),
  [BLOCKS.HR]: () => <hr/>,
  [INLINES.ASSET_HYPERLINK]: node => defaultInline(INLINES.ASSET_HYPERLINK, node),
  [INLINES.ENTRY_HYPERLINK]: node => defaultInline(INLINES.ENTRY_HYPERLINK, node),
  [INLINES.EMBEDDED_ENTRY]: node => defaultInline(INLINES.EMBEDDED_ENTRY, node),
  [INLINES.HYPERLINK]: (node, next, key) => <a key={key} href={node.data.uri}>{next(node.content)}</a>,
};

const defaultMarkRenderers = {
  [MARKS.BOLD]: basicMarkRender('b'),
  [MARKS.ITALIC]: basicMarkRender('i'),
  [MARKS.UNDERLINE]: basicMarkRender('u'),
  [MARKS.CODE]: basicMarkRender('code'),
};

export function richTextDocumentToJSX(richTextDocument, options = {}) {
  if (!richTextDocument || !richTextDocument.content) {
    return '';
  }

  return nodeListToJSX(richTextDocument.content, {
    renderNode: {
      ...defaultNodeRenderers,
      ...options.renderNode,
    },
    renderMark: {
      ...defaultMarkRenderers,
      ...options.renderMark,
    },
  });
}

function nodeListToJSX(nodes, { renderNode, renderMark }) {
  return nodes.map((node, i) => nodeToJSX(node, { renderNode, renderMark }, i));
}

function nodeToJSX(node, { renderNode, renderMark }, key) {
  if (helpers.isText(node)) {
    const nodeValue = escape(node.value);
    if (node.marks.length > 0) {
      return node.marks.reduce((value, mark) => {
        if (!renderMark[mark.type]) {
          return value;
        }
        return renderMark[mark.type](value, key);
      }, nodeValue);
    }

    return nodeValue;
  } else {
    const nextNode = nodes => nodeListToJSX(nodes, { renderMark, renderNode });
    if (!node.nodeType || !renderNode[node.nodeType]) {
      // TODO: Figure what to return when passed an unrecognized node.
      return '';
    }

    return renderNode[node.nodeType](node, nextNode, key);
  }
}